import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import contactInfo from '../contactInfo';
import ContactForm from '../components/ContactForm';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });
  const [product, setProduct] = useState('');
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const prod = params.get('product');
    if (prod) setProduct(prod);
  }, [location.search]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Bouw mailto link
    const mail = contactInfo.address;
    const subject = encodeURIComponent(`Aanvraag via Prints by Jeroen${product ? ' - ' + product : ''}`);
    const body = encodeURIComponent(
      `Naam: ${formData.name}\n` +
      `Email: ${formData.email}\n` +
      `Telefoon: ${formData.phone}\n` +
      (product ? `Product: ${product}\n` : '') +
      `Onderwerp: ${formData.subject}\n` +
      `Bericht:\n${formData.message}`
    );
    window.location.href = `mailto:${mail}?subject=${subject}&body=${body}`;
  };

  return (
    <div className="min-h-screen bg-gray-50" style={{ background: 'var(--color-bg)', color: 'var(--color-text)' }}>
      <div className="container-custom section">
        <div className="text-center mb-12">
          <h1 className="text-3xl font-extrabold text-accent1 sm:text-4xl mb-2">Contact</h1>
          <p className="mt-2 text-lg text-gray-600">
            Heeft u vragen of wilt u meer informatie? Neem gerust contact met ons op.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Formulier card */}
          <div className="card">
            <h2 className="text-2xl font-bold text-accent1 mb-4">Stuur ons een bericht</h2>
            <ContactForm />
          </div>
          {/* Contactgegevens card */}
          <div className="card">
            <h2 className="text-2xl font-bold text-accent1 mb-4">Contactgegevens</h2>
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-medium text-gray-900">Adres</h3>
                <p className="mt-2 text-base text-gray-600">
                  {contactInfo.address}<br />
                  {contactInfo.postalCode} {contactInfo.city}<br />
                  {contactInfo.country}
                </p>
              </div>
              <div>
                <h3 className="text-lg font-medium text-gray-900">Telefoon</h3>
                <p className="mt-2 text-base text-gray-600">
                  {contactInfo.phone}
                </p>
              </div>
              <div>
                <h3 className="text-lg font-medium text-gray-900">Email</h3>
                <p className="mt-2 text-base text-gray-600">
                  <a href={`mailto:${contactInfo.email}`} className="text-accent1 hover:underline">{contactInfo.email}</a>
                </p>
              </div>
              <div>
                <h3 className="text-lg font-medium text-gray-900">Openingstijden</h3>
                {contactInfo.openingHours && (
                  <p className="mt-2 text-base text-gray-600">
                    {contactInfo.openingHours.map((line, i) => <span key={i}>{line}<br /></span>)}
                  </p>
                )}
              </div>
            </div>
            {/* Social Media Links */}
            <div className="mt-8">
              <h3 className="text-lg font-medium text-gray-900">Volg Ons</h3>
              <div className="mt-4 flex space-x-6">
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gray-500">
                  <span className="sr-only">Facebook</span>
                  <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                    <path
                      fillRule="evenodd"
                      d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                      clipRule="evenodd"
                    />
                  </svg>
                </a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gray-500">
                  <span className="sr-only">Instagram</span>
                  <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                    <path
                      fillRule="evenodd"
                      d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                      clipRule="evenodd"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* Map section */}
        <div className="mt-16 card">
          <h2 className="text-2xl font-bold text-accent1 mb-6">Onze Locatie</h2>
          <div className="aspect-w-16 aspect-h-9">
            <iframe
              src={contactInfo.googleMapsUrl}
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              title="Onze locatie"
            />
          </div>
        </div>
      </div>
    </div>
  );
} 